export const QAList = [
  {
    title: "机器换油需要多少升？手工换油需要多少升？",
    content: "您好！机器换油12升，手工换油3升左右。",
  },
  {
    title: "需要不需要区分进出油管？",
    content: "您好！机器是智能识别进出油管所以不需要区分进出油管。",
  },
  {
    title: "循环机换油价格更高？",
    content:
      "<p>您好！我给您算一下吧，在材料价和工时费一样的情况下，如果变速器容量为12升，传统的换油法，为了尽可能的把油换干净，也要用到6-8升油，达到冲洗的效果；循环机换油，损耗更大一些，在10-12升左右。</p><p>两种方式用油量差距不大，价格差距不大，但效果却翻了一倍。而且采用重力换油的话，换油周期更短，没过多久，又应该换了。所以绝对是循环机自动换油省钱省心省时间。</p>",
  },
  {
    title: "没油压还能不能更换？",
    content:
      "您好！是因为波箱设计问题油压低，不影响正常换油 。只要机器连接波箱的管路有温度，说明正在正常换油中。",
  },
  {
    title: "换油前需要注意哪些事项？",
    content:
      "<p>1. 您好！路试（路试方法：在无拥堵的路面上挂D挡行驶，将车速提升使变速器达到最高挡位，然后减速变速器挡位由最高降到最低，挡位变化过程中无冲击、脱挡、打滑等异常。停车后将挡位按D-N-R-N-D方式进行换挡，过程中无冲击、异响现象即可。）</p><p>2. 读取自动变速器故障码-非常重要的变速器状态检查。</p>",
  },
  {
    title: "如何检查油量？",
    content:
      "<p>您好！<p> <p>1. 车辆保持水平；</p> <p>2. 着车，发动机怠速运转；</p> <p>3. 循环切换档位（每个档位停5秒，最后回P位）；</p> <p>3. 用诊断电脑读数当前变速箱油温；</p> <p> 4. 实际油温达到液位检查温度时检查液位；</p><p>5. 路试后进行二次液位检查。</p>",
  },
  {
    title: "手工换油与机器换油有什么区别？",
    content:
      "<p>1. 手工换油：换油周期短，没效果不能保护好零部件，20天时间回到解放前又要更换自动变速箱油得不偿失。</p><p>2. 机器换油：换油周期长，效果明显可以保护好零部件油品几乎是100%的接近出厂状态省钱省心省时间。</p>",
  },
];
